import {get} from 'lodash';

export default (state = {}, {socialMedia}: any) => {
  return {
    ...state,
    socialMedia: {
      ...get(state, 'socialMedia', {}),
      data: {
        ...get(state, 'socialMedia.data', {}),
        ...socialMedia,
      },
    },
  };
};
